import { Box, Container, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import "swiper/css";
import { Swiper, SwiperSlide } from "swiper/react";

// 🔹 Background image (subtle abstract city image)
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import bgMobile from "../assets/images/popular-cities-bg-mobile.png";
import bgDesktop from "../assets/images/popular-cities-bg.png";
import { CITY_IMAGES } from "../assets/images/city-image/cityImages";
// 👆 use the generated image from the prompt

const cities = [
  {
    name: "Lucknow",
    slug: "lucknow",
    image: CITY_IMAGES.lucknow,
  },
  {
    name: "Delhi",
    slug: "delhi",
    image: CITY_IMAGES.delhi,
  },
  {
    name: "Mumbai",
    slug: "mumbai",
    image: CITY_IMAGES.mumbai,
  },
  {
    name: "Kanpur",
    slug: "kanpur",
    image: CITY_IMAGES.kanpur,
  },
  {
    name: "Pune",
    slug: "pune",
    image: CITY_IMAGES.pune,
  },
];

const CARD_WIDTH = 220;
const CARD_HEIGHT = 300;

const PopularCities = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        position: "relative",
        py: { xs: 5, md: 7 },
        backgroundColor: "#FFFFFF",
        borderTop: "1px solid rgba(13,59,102,0.06)",
        overflow: "hidden",
      }}
    >
      {/* ===== BACKGROUND IMAGE ===== */}
      {/* ===== RESPONSIVE BACKGROUND IMAGE ===== */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          backgroundImage: {
            xs: `url(${bgMobile})`,
            md: `url(${bgDesktop})`,
          },
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
          //   opacity: { xs: 0.07, md: 0.05 },
        }}
      />

      {/* ===== BRAND WATERMARK GRADIENTS ===== */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          background: `
            radial-gradient(circle at 15% 30%, rgba(244,211,94,0.14), transparent 45%),
            radial-gradient(circle at 85% 70%, rgba(13,59,102,0.10), transparent 50%)
          `,
          pointerEvents: "none",
        }}
      />

      <Container sx={{ position: "relative", zIndex: 1 }}>
        {/* ===== HEADER ===== */}
        <Box sx={{ mb: 3 }}>
          <Typography
            component="h2"
            sx={{
              fontSize: { xs: "1.8rem", md: "2.3rem" },
              fontWeight: 800,
              color: "#0D3B66",
              letterSpacing: "-0.6px",
            }}
          >
            Popular{" "}
            <Box component="span" sx={{ color: "#F4D35E" }}>
              Cities
            </Box>
          </Typography>

          <Box
            sx={{
              width: 44,
              height: 3,
              borderRadius: 2,
              backgroundColor: "#F4D35E",
              mt: 1,
            }}
          />

          <Typography
            sx={{
              mt: 1.2,
              color: "#4A6F95",
              fontSize: "0.95rem",
              maxWidth: 460,
              lineHeight: 1.6,
            }}
          >
            Discover the most searched cities across India to explore nearby
            places, local attractions and essential services.
          </Typography>
        </Box>

        {/* ===== CITY SLIDER ===== */}
        <Swiper spaceBetween={18} slidesPerView="auto">
          {cities.map((city) => (
            <SwiperSlide key={city.slug} style={{ width: CARD_WIDTH }}>
              <Box
                onClick={() => navigate(`/city/${city.slug}`)}
                sx={{
                  width: CARD_WIDTH,
                  height: CARD_HEIGHT,
                  borderRadius: 2,
                  overflow: "hidden",
                  cursor: "pointer",
                  position: "relative",
                  transition: "transform 0.35s ease, box-shadow 0.35s ease",
                  "&:hover": {
                    transform: "translateY(-6px)",
                  },
                }}
              >
                {/* IMAGE */}
                <Box
                  sx={{
                    position: "absolute",
                    inset: 0,
                    backgroundImage: `url(${city.image})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                  }}
                />

                {/* OVERLAY */}
                <Box
                  sx={{
                    position: "absolute",
                    inset: 0,
                    background:
                      "linear-gradient(180deg, rgba(0,0,0,0.05) 40%, rgba(0,0,0,0.85) 100%)",
                  }}
                />

                {/* CITY NAME */}
                <Box sx={{ position: "absolute", bottom: 14, left: 14 }}>
                  <Typography
                    sx={{
                      color: "#FFFFFF",
                      fontSize: "1.1rem",
                      fontWeight: 700,
                      textShadow: "0 2px 8px rgba(0,0,0,0.6)",
                    }}
                  >
                    {city.name}
                  </Typography>
                </Box>
              </Box>
            </SwiperSlide>
          ))}
        </Swiper>

        {/* ===== SEE ALL ===== */}
        <Box sx={{ mt: 4, textAlign: "center" }}>
          <Typography
            onClick={() => navigate("/city")}
            sx={{
              display: "inline-flex",
              alignItems: "center",
              gap: 0.8,
              cursor: "pointer",
              fontWeight: 600,
              color: "#0D3B66",
              fontSize: "0.95rem",
              "&:hover": {
                color: "#082944",
                textDecoration: "underline",
              },
            }}
          >
            See all cities
            <ArrowForwardIcon fontSize="small" />
          </Typography>
        </Box>

        {/* ===== DIVIDER ===== */}
        <Box
          sx={{
            mt: 5,
            height: 1,
            background:
              "linear-gradient(90deg, transparent, rgba(13,59,102,0.15), transparent)",
          }}
        />
      </Container>
    </Box>
  );
};

export default PopularCities;
